import { z } from 'zod';

import { DAY_OF_WEEK } from 'src/features/workingHours/utils/types';

export type WorkingHoursFormSchemaValues = z.infer<typeof workingHoursFormSchema>;
export const workingHoursFormSchema = z.object({
    all_day: z.boolean(),
    start_time: z.string().or(z.null()),
    end_time: z.string().or(z.null()),
    day_of_week: z.enum(DAY_OF_WEEK),
    zone: z.string().nonempty(),
});

export type CustomWorkingHoursFormSchemaValues = z.infer<typeof customWorkingHoursFormSchema>;
export const customWorkingHoursFormSchema = z.object({
    all_day: z.boolean(),
    start_time: z.string().or(z.null()),
    end_time: z.string().or(z.null()),
    day_of_week: z.array(z.enum(DAY_OF_WEEK)).min(1),
    zone: z.string().nonempty(),
});
